module.exports = __webpack_public_path__ + "media/kkb_low.62b2fb56.mp4";